import { Auth } from "aws-amplify";

class Session {
    static async GetJWTToken() {
        let jwtToken;

        try {
            const response = await Auth.currentSession();

            if (response) {
                jwtToken = response.idToken.jwtToken
            }
        } catch (error) { }

        return jwtToken;
    }

    async IsLoggedIn() {
        return new Promise(async (resolve, reject) => {
            try {
                const jwtToken = await Session.GetJWTToken();

                if (jwtToken === undefined) {
                    resolve(false);
                } else {
                    resolve(true);
                }
            } catch (error) {
                reject(error);
            }
        })
    }
}

export default Session;